export default __webpack_public_path__ + "static/media/1.b8d1285a.png";